import { Controller } from "@hotwired/stimulus";

// Renames a dropdown's trigger after one of its remote items succeeds:
// data-action="ajax:complete->remote-label#update" on the dropdown, and a
// `label` target on the trigger. `update` replaces the target's whole content
// with the item's data-description, or its HTML.
export default class extends Controller {
  static targets = ["label"];

  update(event) {
    const [xhr] = event.detail;
    if (xhr.status !== 200 && xhr.status !== 201) return;

    this.labelTarget.innerHTML =
      event.target.getAttribute("data-description") || event.target.innerHTML;
  }
}
